// src/components/strumenti/SommaAssorbimenti.js
import React, { useState } from "react";
import { RefreshCw, Plus, Trash2 } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"8px 10px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:13, fontFamily:"'Inter',sans-serif", outline:"none" };

export default function SommaAssorbimenti() {
  const [righe, setRighe] = useState([{ id:1, nome:"", qta:"1", mA:"" }]);

  const totale = righe.reduce((s,r) => s + ((parseFloat(r.qta)||0) * (leggiNumero(r.mA)||0)), 0);

  const aggiorna = (id, campo, val) => setRighe(rr => rr.map(r => r.id===id ? {...r,[campo]:val} : r));
  const aggiungi = () => setRighe(rr => [...rr, { id:Date.now(), nome:"", qta:"1", mA:"" }]);
  const rimuovi = id => setRighe(rr => rr.length>1 ? rr.filter(r=>r.id!==id) : rr);

  return (
    <div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 60px 80px 24px", gap:6, marginBottom:6, fontSize:10, fontWeight:700, color:"#9ca3af" }}>
        <div>Dispositivo</div><div>Qta</div><div>mA cad.</div><div></div>
      </div>
      {righe.map(r => (
        <div key={r.id} style={{ display:"grid", gridTemplateColumns:"1fr 60px 80px 24px", gap:6, marginBottom:6, alignItems:"center" }}>
          <input value={r.nome} onChange={e=>aggiorna(r.id,"nome",e.target.value)} style={inp} placeholder="Es. Sensore PIR"/>
          <input value={r.qta} onChange={e=>aggiorna(r.id,"qta",e.target.value)} style={inp}/>
          <input value={r.mA} onChange={e=>aggiorna(r.id,"mA",e.target.value)} style={inp} placeholder="Es. 30"/>
          <button onClick={()=>rimuovi(r.id)} style={{ background:"none", border:"none", color:"#fca5a5", cursor:"pointer" }}><Trash2 size={14}/></button>
        </div>
      ))}
      <button onClick={aggiungi} style={{ display:"flex", alignItems:"center", gap:4, fontSize:12, color:"#dc2626", background:"none", border:"none", cursor:"pointer", marginBottom:16, fontWeight:600 }}>
        <Plus size={13}/> Aggiungi dispositivo
      </button>

      <div style={{ background:"#fef2f2", border:"1px solid #fecaca", borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
        <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>Assorbimento totale</div>
        <div style={{ fontSize:22, fontWeight:800, color:"#dc2626" }}>
          {totale.toLocaleString("it-IT",{maximumFractionDigits:1})}
          <span style={{ fontSize:14, marginLeft:6, color:"#9ca3af" }}>mA</span>
          <span style={{ fontSize:13, marginLeft:8, color:"#9ca3af" }}>({(totale/1000).toLocaleString("it-IT",{maximumFractionDigits:2})} A)</span>
        </div>
      </div>

      <button onClick={()=>setRighe([{ id:Date.now(), nome:"", qta:"1", mA:"" }])}
        style={{ marginTop:16, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
